import { render, staticRenderFns } from "./SupplierInvoiceItemList.vue?vue&type=template&id=68981bee&scoped=true&"
import script from "./SupplierInvoiceItemList.vue?vue&type=script&lang=js&"
export * from "./SupplierInvoiceItemList.vue?vue&type=script&lang=js&"
import style0 from "./SupplierInvoiceItemList.vue?vue&type=style&index=0&id=68981bee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68981bee",
  null
  
)

export default component.exports